// Modules
import Common from "./modules/common";
import blog from "./modules/blog";

// Autoload modules
const modules = [Common, blog];

modules.forEach((module) => {
    module.init();
});

// import local dependencies
import Router from "./utils/Router";
import templateHome from "./partials/template-home";
import templateContacts from "./partials/template-contacts";
import portfolio from "./modules/social-list";
import social from "./partials/social-single";
import single from "./partials/single";
import committees from "./modules/committees-list";

// Populate Router instance with DOM routes
const routes = new Router({
    templateHome,
    templateContacts,
    templateCommittees: committees,
    templateSocialCenters: portfolio,
    archiveSocialCenter: portfolio,
    archiveCommittees: committees,
    singleCommittees: social,
    singleSocialCenter: social,
    single,
});

// Load Events
$(document).ready(() => routes.loadEvents());
